import React, { Component } from 'react';

import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HashLink as Link } from 'react-router-hash-link';
import { Spring } from 'react-spring';

import {
  APIHandler,
  StorageHandler,
  BackVideo,
  DataHandler,
  StoreButtons,
  SweetAlert,
  LanguageSelect,
  NotificationSlider,
} from 'C4';
import { storageKeys, bgVideo } from 'settings';

import SearchInput from 'components/SearchModal/SearchInput';

export default class HomeView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      query: '',
      appId: -1,
      userStatus: 'startTraining',
      noAgent: false,
      germanVersion: false,
      popup: false,
      logo: null,
      landingQuote: null,
    };

    this.close = this.close.bind(this);
  }

  componentWillMount() {
    document.body.classList.add('no-scroll');

    StorageHandler.load(storageKeys.user).then((res) => {
      if (res.training_graduated) {
        return this.setState({ userStatus: 'graduated' });
      }
      if (res.training_started) {
        return this.setState({ userStatus: 'continueTraining' });
      }
      return this.setState({ userStatus: 'startTraining' });
    });
  }

  componentDidMount() {
    const d = new Date(Date.now());
    const leading = (val) => `0${val}`.slice(-2);

    DataHandler.matchAppId().then((appId) => {
      this.setState({ appId });

      StorageHandler.load(storageKeys.user).then((user) => {
        if (user && user.sales_companion_registered === null) {
          const obj = user;
          const date = `${d.getFullYear()}-${leading(
            d.getMonth() + 1
          )}-${leading(d.getDate())}`;
          APIHandler.updateUser(appId, obj.email, [
            { param: 'sales_companion_registered', val: date },
          ]).then((res) => {
            if (res) {
              obj.sales_companion_registered = date;
              StorageHandler.save(storageKeys.user, obj);
            }
          });
        }
      });
    });

    this.getAppInfo();
  }

  componentWillUnmount() {
    document.body.classList.remove('no-scroll');
  }

  setQuery() {
    const { query } = this.state;
    if (query.length > 0) {
      StorageHandler.save(storageKeys.lastSearchQuery, query);
    }
  }

  async getAppInfo() {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    if (appInfo) {
      this.setState({
        logo: appInfo.logoWhite,
        landingQuote: appInfo.landingQuote,
      });
    }
  }

  close() {
    this.setState({
      popup: false,
    });
  }

  render() {
    const { appId, popup, logo, landingQuote } = this.state;

    const open = () => {
      this.setState({
        popup: true,
      });
    };

    return (
      <div className="homeContainer">
        {bgVideo && <BackVideo darken />}
        <div className="bgHome" />
        <div className="buttonWrapper">
          Download now:
          <StoreButtons />
        </div>
        <LanguageSelect />
        <div className="swoop" />
        <Spring
          from={{ transform: 'translateY(30%)', opacity: 0 }}
          to={{ transform: 'translateY(0%)', opacity: 1 }}
        >
          {(props) => (
            <div className="homeView" style={props}>
              <div className="homeView__title">
                <img src={logo} className="homeLogo" alt="logo" />
                {/* <div className="homeView__landing-quote">{landingQuote}</div> */}
                <div className="homeView__title--action">
                  <SearchInput />
                </div>
              </div>
            </div>
          )}
        </Spring>
        {/* <div className="top-bar" />
        <div className="bottom-bar" /> */}
        <div className="bottom-bg" />
        <div className="bottomLine" />

        <NotificationSlider appId={appId} middle right />

        <SweetAlert
          title=""
          trigger={popup}
          {...{
            title: '',
            html: 'PONANT Explorer Rewards are available once you receive your diploma as a certified PONANT Expert. Please complete the Learning chapters and come back to submit your bookings.',
            confirmButtonText: i18n.translate('general.close'),
            onClose: this.close,
          }}
        />
      </div>
    );
  }
}
